// UserPage.js

import React, { useEffect, useState } from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Body from "../components/Body";
import { API_path } from "../service/apiPath";
import axiosInstance from "../service/axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import displayNavOptions from "../const/components";

const UserPage = () => {
  const lsUserVO = process.env.REACT_APP_LS_USER_VO;
  const [pimsUserVO, setPimsUserVO] = useState(() => {
    const storedUserVO = localStorage.getItem(lsUserVO);
    return storedUserVO ? JSON.parse(storedUserVO) : null;
  });
  const [selectedOption, setSelectedOption] = useState(
    () => localStorage.getItem("navOption") || "stockDetails"
  );
  const [navOptions, setNavOptions] = useState([]);
  const [hasError, setHasError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to login if user is not logged in
    if (!pimsUserVO || !pimsUserVO.isLoggedin) {
      navigate("/login");
    } else {
      fetchUserOptions();
    }
  }, [pimsUserVO, navigate]);

  const fetchUserOptions = async () => {
    try {
      const response = await axiosInstance.get(API_path.getUserOption, {
        params: {
          userId: pimsUserVO.userId,
        },
      });
      const responseData = response.data;
      if (responseData.statusFlag === "Ok" && responseData.status) {
        const userOptionVO = responseData.paramObjectsMap.userOptionVO;
        const visibleOptions = Object.entries(userOptionVO)
          .filter(([key, value]) => typeof value === "boolean" && value)
          .map(([key, value]) => ({
            displayName: displayNavOptions[key].displayName,
            optionVal: key,
            visible: value,
          }));
        setNavOptions(visibleOptions);
        if (visibleOptions.length === 0) {
          setHasError(true);
        }
      } else {
        toast.error(responseData.paramObjectsMap.message);
        setHasError(true);
      }
    } catch (error) {
      console.error("Failed to fetch user options:", error);
      toast.error("Failed to fetch user options");
      setHasError(true);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Nav
        setSelectedOption={setSelectedOption}
        selectedOption={selectedOption}
        navOptions={navOptions}
        hasError={hasError}
      />
      <Body
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        navOptions={navOptions}
      />
      <Footer />
    </div>
  );
};

export default UserPage;
